import * as React from "react";
const SVGComponent = (props) => (
  <svg
    viewBox="0 0 1440 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="h-10"
  >
    <rect width={1440} height={64} fill="url(#paint0_linear_19_279)" />
    <defs>
      <linearGradient
        id="paint0_linear_19_279"
        x1={1440}
        y1={31.9999}
        x2={505.5}
        y2={32.0005}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.722048} stopColor="#D9D9D9" />
        <stop offset={1} stopColor="#D9D9D9" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
